import { useMemo } from 'react';
import { useUserStore } from '@core/user/useUserStore';
import { usePermissionStore } from '@core/permission/usePermissionStore';
import { buildPortalAccessContext } from '@/access/buildPortalAccessContext';
import type { PortalAccessContext } from '@/access/portalAccess.types';

const usePortalAccess = (): PortalAccessContext => {
  const role = useUserStore((state) => state.currentUser?.role);
  const permissions = usePermissionStore((state) => state.permissions);
  const status = usePermissionStore((state) => state.status);

  return useMemo(
    () => buildPortalAccessContext(role, { permissions, status }),
    [role, permissions, status],
  );
};

export default usePortalAccess;
